import { useSlicerOptionDateRange } from './slicer-timerange-info.hook';
import { memo, MouseEvent as ReactMouseEvent, ReactNode } from 'react';
import {
  StyledLabelGroup,
  StyledSlicerGroup,
  StyledSlicerGroupFlex,
} from './slicer-timerange-info.styles';
import Checkbox from '@mui/material/Checkbox';
import { kebabCase, noop } from 'lodash';
import { messages } from '../../../../../i18n';
import { FormatDateRange } from '../../../../filter/relative-date-condition/format-date-range';
import { TimePeriods } from '../../../../filter/relative-date-condition';
import { TimestampSlicerTypes } from '../../../interfaces';

interface ITimeRangeInfoBoxProps {
  scalarValue: number;
  timePeriod: keyof typeof TimePeriods;
  includeCurrentPartial: boolean;
  fieldName: string;
  type: TimestampSlicerTypes;
  includeCurrentPartialClickHandler: (checked: boolean) => void;
}
export const SlicerTimeRangeInfo = memo<ITimeRangeInfoBoxProps>(
  ({
    scalarValue,
    timePeriod,
    includeCurrentPartial,
    fieldName,
    type,
    includeCurrentPartialClickHandler,
  }) => {
    const hidePartial = type === TimestampSlicerTypes.CURRENT_AND_PREV;

    const { dateTimeFormat, datasetId, useFiscalCalendar, relativeDatesState } =
      useSlicerOptionDateRange({
        scalarValue,
        timePeriod,
        includeCurrentPartial,
        fieldName,
        type,
      });

    return (
      <TimeRangeInfo
        fieldName={fieldName}
        onPartialPeriodClick={() =>
          includeCurrentPartialClickHandler(!includeCurrentPartial)
        }
        isPartialPeriodChecked={!hidePartial && includeCurrentPartial}
        showPartialPeriod={
          !hidePartial && relativeDatesState.displayFractionalPeriod
        }
      >
        <FormatDateRange
          useFiscalCalendar={useFiscalCalendar}
          datasetId={datasetId}
          relativeDatesState={relativeDatesState}
          dateTimeFormat={dateTimeFormat}
        />
      </TimeRangeInfo>
    );
  },
);

export const TimeRangeInfo = ({
  children,
  fieldName = '',
  showPartialPeriod = true,
  isPartialPeriodChecked = false,
  onPartialPeriodClick = noop,
}: {
  children: ReactNode;
  fieldName?: string;
  showPartialPeriod?: any;
  isPartialPeriodChecked?: boolean;
  onPartialPeriodClick?: (event: ReactMouseEvent<Element, MouseEvent>) => void;
}) => {
  if (!showPartialPeriod) {
    return <StyledSlicerGroupFlex>{children}</StyledSlicerGroupFlex>;
  }

  return (
    <StyledSlicerGroupFlex>
      <StyledSlicerGroup>
        <Checkbox
          id={`include-fractional-period-${kebabCase(fieldName)}`}
          checked={isPartialPeriodChecked}
          sx={{ padding: 0 }}
          size={'small'}
          onClick={onPartialPeriodClick}
        />
        <StyledLabelGroup>
          <label
            className={'control-label'}
            htmlFor={`include-fractional-period-${kebabCase(fieldName)}`}
          >
            {messages.filters.includeCurrentPartialPeriod}
          </label>
          {children}
        </StyledLabelGroup>
      </StyledSlicerGroup>
    </StyledSlicerGroupFlex>
  );
};
